module.exports = __webpack_public_path__ + "img/spot-pink-3.png";